<template lang="pug">
aside.version-container {{ versionString }}
</template>

<!-- eslint-disable @typescript-eslint/no-unused-vars -->
<script lang="ts" setup>
import { computed } from 'vue';

const appVersion = VERSION;
const appEnv = ENVIRONMENT;
const appBuild = BUILD_HASH;
const versionString = computed(() => (`Version ${appVersion}${appEnv === 'development' ? '_DEV' : ''}`));
</script>
<style lang="scss">
.version-container{
    position: fixed;
    bottom: 5px;
    right: 1rem;
    padding: 0.25rem 0.5rem;
    color: black;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 5px;
}
</style>